import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface PaymentTimelineItem {
  date: string;
  dayOfWeek: string;
  dayOfMonth: number;
  totalAmount: number;
  paymentCount: number;
}

export interface DashboardScheduledUpcomingOverviewResponse {
  expectedRevenueNext7Days: number;
  expectedRevenueNext30Days: number;
  paymentTimeline: Array<PaymentTimelineItem>;
}

export const dashboardScheduledUpcomingOverviewAPI = async () => {
  const response =
    await baseAPI.get<DashboardScheduledUpcomingOverviewResponse>(
      '/dashboard/scheduled-upcoming-overview',
    );
  return response.data;
};

export const useDashboardScheduledUpcomingOverview = () => {
  return useQuery({
    queryKey: [KEYS.DASHBOARD_SCHEDULED_UPCOMING_OVERVIEW],
    queryFn: dashboardScheduledUpcomingOverviewAPI,
  });
};
